var map = {
	"./main_de.json": 346,
	"./main_en.json": 347,
	"./main_es.json": 348,
	"./main_fr.json": 349,
	"./main_it.json": 350,
	"./main_pt.json": 351,
	"./main_sl.json": 352,
	"./main_zh-TW.json": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 345;